import React from 'react';
import styled from 'styled-components';
import { VehicleModelProps } from './car-model';
import { VehicleSide } from '../../enums';
import VehicleStateImg from './vehicle-state-img';
import QuarterPanelImg from '../../assets/images/car-model/quarter_panel.png';

interface Props extends VehicleModelProps {
  side: VehicleSide;
}

const QUARTER_PANEL_STYLES = {
  [VehicleSide.Left]: 0,
  [VehicleSide.Right]: 180,
};

class VehicleQuarterPanel extends React.Component<Props, any> {
  getVehicleItem = () => `${this.props.side}-quarter-panel`;

  clickHandler = () => {
    const { clickHandler } = this.props;
    clickHandler && clickHandler(this.getVehicleItem());
  };

  render() {
    const { className, vehicleState } = this.props;
    const vehicleItem = this.getVehicleItem();

    return (
      <VehicleStateImg
        className={`${className} ${vehicleState[vehicleItem]}`}
        src={QuarterPanelImg}
        onClick={this.clickHandler}
      />
    );
  }
}

const StyledVehicleQuarterPanel = styled(VehicleQuarterPanel)`
  position: relative;
  width: 4.5em;
  margin-top: 1.5em;
  transform: rotateY(${({ side }) => QUARTER_PANEL_STYLES[side]}deg);
`;

export default StyledVehicleQuarterPanel;
